module.exports = __webpack_public_path__ + "img/applyRecords.3bd24026.svg";